import type { ApostasPorSegmento, Segmento } from '@bi-evox/contrato';
import { fmtInteiro, fmtReais } from '../lib/formato';

export const SEGMENTOS: { id: Segmento; rotulo: string; titulo: string; explicacao: string }[] = [
  { id: 'total', rotulo: 'Total', titulo: 'GGR total', explicacao: 'Cassino e esportes juntos, como Apostas e Prêmios no painel da Evox.' },
  { id: 'cassino', rotulo: 'Cassino', titulo: 'GGR do cassino', explicacao: 'Todos os jogos, menos as apostas esportivas.' },
  { id: 'esportes', rotulo: 'Esportes', titulo: 'GGR de esportes', explicacao: 'Apostas esportivas, já com os ajustes da Altenar.' },
];

/** Um cartão de GGR por segmento: total, cassino e esportes. */
export function CartoesApostas({ total }: { total: ApostasPorSegmento }) {
  return (
    <div className="kpis">
      {SEGMENTOS.map((s) => (
        <article key={s.id} className="kpi">
          <h3>{s.titulo}</h3>
          <p className="kpi-valor">{fmtReais(total[s.id].ggr)}</p>
          <p className="kpi-apoio">
            {fmtReais(total[s.id].apostado)} apostados por {fmtInteiro(total[s.id].jogadores)} jogadores
          </p>
          <p className="kpi-expl">{s.explicacao}</p>
        </article>
      ))}
    </div>
  );
}
